<template>
  <div>
    <HomeCategoriesComponent
      v-if="allTopics.home"
      :link="allTopics.home"
      class="gadget"
    >
    </HomeCategoriesComponent>
    <ImageTopicsComponent
      class="gadget"
      v-if="allTopics.images && allTopics.home"
      :link="allTopics.home"
      :topics="allTopics.images"
    >
    </ImageTopicsComponent>
    <HomeTextTopicComponent
      v-if="allTopics.texts && allTopics.home"
      :link="allTopics.home"
      :topics="allTopics.texts"
    >
    </HomeTextTopicComponent>
    <AllCities v-if="allTopics.city" :city="allTopics.city"> </AllCities>
    <Footer></Footer>
  </div>
</template>

<script>
import AllCities from "@/views/AllCities";
import ImageTopicsComponent from "@/components/ImageTopicsComponent";
import HomeTextTopicComponent from "@/components/HomeTextTopicComponent";
import HomeCategoriesComponent from "@/components/HomeCategoriesComponent";
import Footer from "@/components/Footer";
import {mapMutations} from "vuex";
export default {
  name: "home",
  metaInfo: {
    title: "首页"
  },
  data: function() {
    return {
      allTopics: [],
      message: ""
    };
  },
  components: {
    HomeCategoriesComponent,
    HomeTextTopicComponent,
    ImageTopicsComponent,
    AllCities,
    Footer
  },
  mounted: function() {
    this.getData();
  },

  methods: {
    ...mapMutations(["setLoading"]),
    getData() {
      this.setLoading(true);
      this.$axios
        .get("/")
        .then(res => {
          this.allTopics = res.data;
          this.setLoading(false);
        })
        .catch(e => {
          this.setLoading(false);
          console.log(e);
          this.$message({
            type: "error",
            showClose: true,
            message: "首页加载失败，请稍后再试"
          })
        });
    }
  }
};
</script>
